import * as React from 'react';
import styled from 'styled-components';
import { SelectField } from '../../designSystem/formField/SelectField';
import { ProtectedPageWrapper } from '../../designSystem/layouts/pageWrappers/ProtectedPageWrapper';
import { ButtonOverview } from './components/ButtonOverview';
import { PageSectionHeaderOverview } from './components/PageSectionHeaderOverview';
import { ColorOverview } from './components/ColorOverview';
import { ContainerOverview } from './components/ContainerOverview';
import { tablet } from '../../designSystem/BreakPoints';
import { CardsOverview } from './components/CardsOverview';
import { DateTimeOverview } from './components/DateTimeOverview';
import { FieldChangePanelOverview } from './components/FieldChangePanelOverview';
import { FileLinkCommentOverview } from './components/FileLinkCommentOverview';
import { FormComponentsOverview } from './components/FormComponentsOverview';
import { FormFieldOverview } from './components/FormFieldOverview';
import { GraphicsOverview } from './components/GraphicsOverview';
import { HtmlEditorOverview } from './components/HtmlEditorOverview';
import { IconOverview } from './components/IconOverview';
import { InspectionPointOverview } from './components/InspectionPointOverview';
import { LayoutOverview } from './components/LayoutOverview';
import { ListRowOverview } from './components/ListRowOverview';
import { ModalOverview } from './components/ModalOverview';
import { SelectionOverview } from './components/SelectionOverview';
import { TabOverview } from './components/TabOverview';
import { TextInputOverview } from './components/TextInputOverview';
import { TooltipOverview } from './components/TooltipOverview';
import { TypographyOverview } from './components/TypographyOverview';
import { PageSectionOverview } from './components/PageSectionOverview';
import { ChipOverview } from './components/ChipOverview';
import { ListItemOverview } from './components/ListItemOverview';

const Page = styled.div`
    padding: 20px;
    margin: 50px;

    @media (max-width: ${tablet}px) {
        margin:0;
    }
`;


const Pages = ['Colors', 'Typography', 'Buttons', 'TextInput', 'Selection', 'FormField', 'DateTime', 'Cards and messages', 'Modal', 'Icons', 'Graphics', 'Tooltip', 'Layout', 'Containers', 'ListRow', 'Tab', 'InspectionPoints', 'FieldChangePanel', 'FormComponents', 'HtmlEditor', 'FileLinkComment', 'PageSectionHeader', 'PageSection', 'Chip', 'ListItem'] as const;
type PageType = typeof Pages[number];
const defaultPageType: PageType = 'Chip';



export function DesignSystem (): JSX.Element
{
    const [page, setPage] = React.useState<PageType>(() =>
    {
        // getting stored value
        const saved = localStorage.getItem("DesignSystemPage");
        return (saved || defaultPageType) as PageType;
    });

    React.useEffect(() =>
    {
        localStorage.setItem("DesignSystemPage", page);
    }, [page]);

    return (
        <ProtectedPageWrapper requiredPermissions={['UserAdmin']}>
            <Page>
                <div style={{ width: '200px', marginBottom: '10px' }}>
                    <SelectField
                        selectedValue={page}
                        options={Pages.map(p => ({ text: p, value: p })).sort((a, b) => a.text.localeCompare(b.text))}
                        onChange={newValue => setPage(newValue as PageType)}
                        label="Vælg afsnit"
                    />
                </div>

                <DesignSystemContainer>
                    {page === 'Buttons' &&
                        <ButtonOverview />
                    }
                    {page === 'Cards and messages' &&
                        <CardsOverview />
                    }
                    {page === 'Colors' &&
                        <ColorOverview />
                    }
                    {page === 'DateTime' &&
                        <DateTimeOverview />
                    }
                    {page === 'FormField' &&
                        <FormFieldOverview />
                    }
                    {page === 'Typography' &&
                        <TypographyOverview />
                    }
                    {page === 'Icons' &&
                        <IconOverview />
                    }
                    {page === 'Modal' &&
                        <ModalOverview />
                    }
                    {page === 'Selection' &&
                        <SelectionOverview />
                    }
                    {page === 'TextInput' &&
                        <TextInputOverview />
                    }
                    {page === 'Graphics' &&
                        <GraphicsOverview />
                    }
                    {page === 'Tooltip' &&
                        <TooltipOverview />
                    }
                    {page === 'Layout' &&
                        <LayoutOverview />
                    }
                    {page === 'Containers' &&
                        <ContainerOverview />
                    }
                    {page === 'ListRow' &&
                        <ListRowOverview />
                    }
                    {page === 'Tab' &&
                        <TabOverview />
                    }
                    {page === 'InspectionPoints' &&
                        <InspectionPointOverview />
                    }
                    {page === 'FieldChangePanel' &&
                        <FieldChangePanelOverview />
                    }
                    {page === 'FormComponents' &&
                        <FormComponentsOverview />
                    }
                    {page === 'HtmlEditor' &&
                        <HtmlEditorOverview />
                    }
                    {page === 'FileLinkComment' &&
                        <FileLinkCommentOverview />
                    }
                    {page === 'PageSectionHeader' &&
                        <PageSectionHeaderOverview />
                    }
                    {page === 'PageSection' &&
                        <PageSectionOverview />
                    }
                    {page === 'Chip' &&
                        <ChipOverview />
                    }
                    {page === 'ListItem' &&
                        <ListItemOverview />
                    }
                </DesignSystemContainer>
            </Page>
        </ProtectedPageWrapper>
    );
}

const DesignSystemContainer = styled.div`
    /* border: 1px solid gray;
    border-radius: 4px;
    padding: 20px; */
`;